<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				size="mini"
				@row-dblclick='rowClick'
				:height="tableHeight"
				ref="table"
				@select="selectionChangeHandle"
				@select-all="selectionChangeHandle"
			>
				<el-table-column
					type="selection"
					align="center"
					width="55">
				</el-table-column>
				<el-table-column
					label-class-name="column-index"
					label="序号"
					type="index"
					width="70"
					align="center">
				</el-table-column>
				<el-table-column
					prop="name"
					label="常购单名称"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					label="商品明细"
					align="center"
					min-width="150">
					<template slot-scope="scope">
						<div style="display: flex;align-items: center;overflow: hidden;flex-wrap: nowrap;justify-content: center;">
							<el-tooltip class="item" effect="dark" :content="scope.row.pname" placement="top">
								<div style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;display: inline-block;">{{scope.row.pname}}</div>
							</el-tooltip>
							<dic style='min-width: 20px;flex-shrink:0'>({{scope.row.pcount}}件)</dic>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="适用门店"
					align="center"
					min-width="150">
					<template slot-scope="scope">
						<div style="color: var(--fx-primary-color);" v-if="scope.row.shopattendway === 0">全部门店</div>
						<el-tooltip v-else class="item" effect="dark" :content="scope.row.shopnames" placement="top">
							<div style="color: var(--fx-primary-color);">{{scope.row.shopcnt}}家</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column
					label="适用客户"
					align="center"
					min-width="150">
					<template slot-scope="scope">
						<div style="color: var(--fx-primary-color);" v-if="scope.row.customerattendway === 0">全部客户</div>
						<el-tooltip v-else class="item" effect="dark" :content="scope.row.customernames" placement="top">
							<div style="color: var(--fx-primary-color);">{{scope.row.customercnt}}家</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column
					prop="disabledflag"
					label="常购单状态"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button class="Yahei" type='text' size="mini" icon="el-icon-delete" @click="delGoods(scope.row)">删除</el-button>
						<el-button class="Yahei" type='text' size="mini" icon="el-icon-search" @click="getDetail(scope.row)">查看</el-button>
						<el-button class="Yahei" type='text' size="mini" icon="el-icon-document" @click="copy(scope.row)">复制</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		totalCount: Number,
		tableData: Array
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: 1,
				size: 20
			},
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id'
			})
		}
	},
	created () {
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		initTableData () {
			this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
		},
		clear () {
			this.tableSelectUtils.clear()
		},
		rowClick (row, column, event) {
			this.getDetail(row)
		},
		selectionChangeHandle (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			let value = this.tableSelectUtils.getSelectRows()
			let ids = value.map(item => {
				return item.id
			})
			this.$emit('delIds', ids)
		},
		handleSizeChange (value) {
			this.$emit('sizeChange', value)
			this.pagination.size = value
		},
		handlePageChange (value) {
			this.$emit('pageChange', value)
			this.pagination.page = value
		},
		getDetail (data) {
			console.log(data)
			this.$router.push({ path: '/main/purchaseOrder', query: { id: data.id } })
		},
		copy (data) {
			let params = {
				regularpurchaseListId: data.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/regularPurchase/copy`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('复制成功！')
					this.$emit('copySuc')
				} else {
					this.$message.error('复制失败！')
				}
			})
		},
		delGoods (data) {
			this.$confirm('是否删除常购单？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					listidArr: data.id
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/regularPurchase/delete`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功！')
						this.$emit('delSuc')
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	height: 100%
	min-height: 0
	width: 100%;
	.main-table-box {
		flex: 1
		padding-bottom 10px
		min-height: 0;
		overflow-y: auto;
	}
	.Yahei {
		font-family: 'Microsoft Yahei'
	}
}
</style>
